import React, { useEffect, useRef, useState } from 'react';
import { render } from '@divkitframework/divkit/client';
import '@divkitframework/divkit/dist/client.css';

interface DivKitCardProps {
  json: any;
  id: string;
}

const DivKitCard: React.FC<DivKitCardProps> = ({ json, id }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [renderError, setRenderError] = useState<string>('');

  useEffect(() => {
    if (!targetRef.current) return;

    setRenderError('');
    let instance: { $destroy(): void } | null = null;
    // DivKit reports structural problems through onError instead of throwing;
    // only errors raised synchronously during render() are treated as fatal.
    let mounting = true;
    try {
      instance = render({
        target: targetRef.current,
        json,
        id,
        onError: (details) => {
          console.error('DivKit error:', details.error);
          if (mounting && details.error.level === 'error') {
            setRenderError(details.error.message);
          }
        },
      });
    } catch (error: any) {
      setRenderError(error.message || String(error));
    }
    mounting = false;

    return () => {
      instance?.$destroy();
    };
  }, [json, id]);

  if (renderError) {
    return (
      <div>
        <div style={{ fontWeight: 600, marginBottom: 8, color: '#8b0000' }}>
          Failed to render DivKit card: {renderError}
        </div>
        <pre style={{
          background: '#f5f5f5',
          padding: 8,
          borderRadius: 4,
          fontSize: 12,
          overflow: 'auto',
          fontFamily: 'Monaco, Consolas, "Courier New", monospace'
        }}>
          {JSON.stringify(json, null, 2)}
        </pre>
      </div>
    );
  }

  // Cards may use fixed widths wider than the bubble — scroll instead of overflowing
  return <div ref={targetRef} style={{ maxWidth: '100%', overflowX: 'auto' }} />;
};

export default DivKitCard;
